// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"NotificationTemplateEdit_buttonsContainer__2QkYi","formSectionWrapper":"NotificationTemplateEdit_formSectionWrapper__2-xU4"};